import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select  from 'react-select'
import { mapValidationFieldsToClassName } from '../../forms/inputValidations'

import 'react-select/dist/react-select.css'
import './nos-selector.less'

class NOSSelector extends Component {
    render () {
        return (
            <div className="nos-selector-container">
                <label className="nos-selector-label" htmlFor="nos-selector">Nature of Suit: </label>
                <div className={this.props.className}>
                    <Select
                        name="nos-field-name"
                        options={nosOptions}
                        multi={true}
                        simpleValue={true}
                        value={this.props.filters.get('nos')}
                        placeholder="Select..."
                        onChange={ (nos) => this.props.onChange({ nos: nos || '' }) } />
                </div>
            </div>
        )
    }
}

export default connect(state => mapValidationFieldsToClassName(state, 'nos', 'nos-selector'))(NOSSelector)


// these are also available in a CSV file in Drupal
const nosOptions = [
    { value: '110', label: '110 Insurance'},
    { value: '120', label: '120 Contract: Marine'},
    { value: '130', label: '130 Miller Act'},
    { value: '140', label: '140 Negotiable Instrument'},
    { value: '150', label: '150 Contract: Recovery/Enforcement'},
    { value: '151', label: '151 Contract: Recovery Medicare'},
    { value: '152', label: '152 Contract: Recovery Student Loan'},
    { value: '153', label: '153 Contract: Recovery Veteran Benefits'},
    { value: '160', label: '160 Stockholders Suits'},
    { value: '190', label: '190 Contract: Other'},
    { value: '195', label: '195 Contract Product Liability'},
    { value: '196', label: '196 Contract: Franchise'},
    { value: '210', label: '210 Condemnation'},
    { value: '220', label: '220 Real Property: Foreclosure'},
    { value: '230', label: '230 Rent Lease &amp; Ejectment'},
    { value: '240', label: '240 Torts to Land'},
    { value: '245', label: '245 Tort Product Liability'},
    { value: '290', label: '290 Real Property: Other'},
    { value: '310', label: '310 Airplane'},
    { value: '315', label: '315 Airplane Product Liability'},
    { value: '320', label: '320 Assault Libel &amp; Slander'},
    { value: '330', label: '330 Federal Employer\'s Liability'},
    { value: '340', label: '340 Marine'},
    { value: '345', label: '345 Marine Product Liability'},
    { value: '350', label: '350 Motor Vehicle'},
    { value: '355', label: '355 Motor Vehicle Product Liability'},
    { value: '360', label: '360 P.I.: Other'},
    { value: '362', label: '362 Personal Injury Medical Malpractice'},
    { value: '365', label: '365 Personal Injury Product Liability'},
    { value: '367', label: '367 TORTS - Personal Injury - Health Care/Pharmaceutical Personal Injury/Product Liability'},
    { value: '368', label: '368 P.I. : Asbestos'},
    { value: '370', label: '370 Fraud or Truth-In-Lending'},
    { value: '371', label: '371 Truth in Lending'},
    { value: '375', label: '375 False Claims Act'},
    { value: '380', label: '380 Personal Property: Other'},
    { value: '385', label: '385 Prop. Damage Prod. Liability'},
    { value: '400', label: '400 State Reapportionment'},
    { value: '410', label: '410 Anti-Trust'},
    { value: '422', label: '422 Bankruptcy Appeal (801)'},
    { value: '423', label: '423 Bankruptcy Withdrawl'},
    { value: '430', label: '430 Banks and Banking'},
    { value: '440', label: '440 Civil Rights: Other'},
    { value: '441', label: '441 Civil Rights: Voting'},
    { value: '442', label: '442 Civil Rights: Jobs'},
    { value: '443', label: '443 Civil Rights: Accomodations'},
    { value: '444', label: '444 Civil Rights: Welfare'},
    { value: '445', label: '445 Civil Rights: Americans with Disabilities - Employment'},
    { value: '446', label: '446 Civil Rights: Americans with Disabilities - Other'},
    { value: '448', label: '448 Civil Rights: Education'},
    { value: '450', label: '450 Commerce ICC Rates, Etc.'},
    { value: '460', label: '460 Deportation'},
    { value: '462', label: '462 Naturalization Application'},
    { value: '463', label: '463 Habeas Corpus - Alien Detainee'},
    { value: '465', label: '465 Other Immigration Actions'},
    { value: '470', label: '470 Racketeer/Corrupt Organization'},
    { value: '480', label: '480 Consumer Credit'},
    { value: '490', label: '490 Cable/Satellite TV'},
    { value: '510', label: '510 Prisoner: Vacate Sentence'},
    { value: '530', label: '530 Habeas Corpus (General)'},
    { value: '535', label: '535 Death Penalty - Habeas Corpus'},
    { value: '540', label: '540 Mandamus &amp; Other'},
    { value: '550', label: '550 Prisoner: Civil Rights'},
    { value: '555', label: '555 Habeas Corpus (Prison Condition)'},
    { value: '560', label: '560 Prisoner Petitions - Civil Detainee - Conditions of Confinement'},
    { value: '610', label: '610 Forfeit/Penalty: Agriculture'},
    { value: '620', label: '620 Forfeit/Penalty: Food and Drug'},
    { value: '625', label: '625 Drug Related Seizure of Property'},
    { value: '630', label: '630 Forfeit/Penalty: Liquor Laws'},
    { value: '640', label: '640 Forfeit/Penalty: R.R. &amp; Truck'},
    { value: '650', label: '650 Forfeit/Penalty: Airline Regulations'},
    { value: '660', label: '660 Forfeit/Penalty: Occupational Safety'},
    { value: '690', label: '690 Forfeit/Penalty: Other'},
    { value: '710', label: '710 Labor: Fair Standards'},
    { value: '720', label: '720 Labor: Labor/Management Relations'},
    { value: '730', label: '730 Labor: Reporting/Disclosure'},
    { value: '740', label: '740 Labor: Railway Labor Act'},
    { value: '751', label: '751 Labor: Family and Medical Leave Act'},
    { value: '790', label: '790 Labor: Other'},
    { value: '791', label: '791 Labor: E.R.I.S.A.'},
    { value: '810', label: '810 Selective Service'},
    { value: '820', label: '820 Copyright'},
    { value: '830', label: '830 Patent'},
    { value: '840', label: '840 Trademark'},
    { value: '850', label: '850 Securities/Commodities'},
    { value: '861', label: '861 Social Security: HIA'},
    { value: '862', label: '862 Social Security: Black Lung'},
    { value: '863', label: '863 Social Security: DIWC/DIWW'},
    { value: '864', label: '864 Social Security: SSID Tit. XVI'},
    { value: '865', label: '865 Social Security: RSI Tax Suits'},
    { value: '870', label: '870 Taxes'},
    { value: '871', label: '871 Tax Suits: IRS-Third Party'},
    { value: '875', label: '875 Taxes: Customer Challenge'},
    { value: '890', label: '890 Other Statutory Actions'},
    { value: '891', label: '891 Agriculture Acts'},
    { value: '892', label: '892 Economic Stabilization Act'},
    { value: '893', label: '893 Environmental Matters'},
    { value: '894', label: '894 Energy Allocation Act'},
    { value: '895', label: '895 Freedom of Information Act'},
    { value: '896', label: '896 Other Statues - Arbitration'},
    { value: '899', label: '899 Other Statues - Administrative Procedure Act/Review or Appeal of Agency Decision'},
    { value: '900', label: '900 Appeal of Fee Determination'},
    { value: '950', label: '950 Constitutional - State Statute'},
    { value: 'ZZZ', label: 'Other Nature of Suit'},
]



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/nosSelector/NOSSelector.js
 **/